export default __webpack_public_path__ + "static/media/word-icon.b0d02c39.png";